
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BlockTitleEditorComponent } from './block-title-editor.component';
import { TextModule } from 'libraries/module/formbuilder/fields/text/text.module';

@NgModule({
    imports: [
        CommonModule,
        TextModule,
    ],
    declarations: [
        BlockTitleEditorComponent,
    ],
    exports: [
        BlockTitleEditorComponent,
    ],
})
export class BlockTitleEditorModule {}